<template>
  <div class="vacancy-edit-progress"
       :class="isOpen ? '_open' : null"
  >
    <div class="vacancy-edit-progress__head">
      <ProgressBar class="vacancy-edit-progress__bar"
                   :progress="progress"
                   :inlineVal="isSlide"
      />
      <div v-if="isSlide"
           class="vacancy-edit-progress__btn-toggle"
           @click.prevent="onSlideToggle"
      >
        <BaseSvg name="ico-arrow-light"/>
      </div>
    </div>
    <v-slide-toggle v-if="isSlide"
                    :active="isOpen"
                    class="vacancy-edit-progress__toggle">
      <div class="vacancy-edit-progress__content">
        <OverlayScrollbarsComponent class="vacancy-edit-progress__content-inner">
          <div v-for="(item, index) in resultList"
               :key="index"
               class="vacancy-edit-progress__list-group">
            <h4 class="vacancy-edit-progress__list-title">{{$tNewVacancy(item.title)}}</h4>
            <ul class="vacancy-edit-progress__list">
              <li v-for="(subItem, subItemIndex) in item.subItems"
                  :key="subItemIndex"
                  :class="subItem[1] ? '_done' : null"
                  class="vacancy-edit-progress__list-item">
                <BaseSvg name="ico-check"/>
                <a href="#vacancy-title" v-scroll-to="{
                   el: '#vacancy-title',
                   offset: -100,
                 }">
                  {{$tNewVacancy(subItem[0])}}
                </a>
              </li>
            </ul>
          </div>
        </OverlayScrollbarsComponent>
      </div>
    </v-slide-toggle>
    <div v-else
         class="vacancy-edit-progress__content">
      <OverlayScrollbarsComponent
        class="vacancy-edit-progress__content-inner">
        <div v-for="(item, index) in resultList"
             :key="index"
             class="vacancy-edit-progress__list-group">
          <h4 class="vacancy-edit-progress__list-title">{{$tNewVacancy(item.title)}}</h4>
          <ul class="vacancy-edit-progress__list">
            <li v-for="(subItem, subItemIndex) in item.subItems"
                :key="subItemIndex"
                :class="subItem[1] ? '_done' : null"
                class="vacancy-edit-progress__list-item">
              <BaseSvg name="ico-check"/>
              <a :href="subItem[2]"
                 v-scroll-to="{
                   el: subItem[2],
                   offset: -80,
                 }">
                {{$tNewVacancy(subItem[0])}}
              </a>
            </li>
          </ul>
        </div>
      </OverlayScrollbarsComponent>
      <div class="vacancy-edit-progress__scroll-btn">
        <BaseSvg name="ico-arrow"/>
      </div>
    </div>

  </div>
</template>

<script>
  import 'overlayscrollbars/css/OverlayScrollbars.css'
  import {OverlayScrollbarsComponent} from 'overlayscrollbars-vue';
  import ProgressBar from "./ProgressBar";
  import isFilledJSONValue from "../helpers/isFilledJSONValue";

  const items = [{
    title: 'Main',
    subItems: {
      'Vacancy title': (state) => {
        return {
          check: isFilledJSONValue(state.vacancyEdit.main.inputs.title.value),
          sectionId: '#vacancy-title'
        }
      },
      'Field of activity': (state) => {
        return {
          check:state.vacancyEdit.main.inputs.category_id.value,
          sectionId: '#vacancy-field-of-activity'
        }
      },
      // 'Job types': (state) => {
      //   return {
      //     check: isFilledJSONValue(state.vacancyEdit.main.jobTypes.job_types),
      //     sectionId: '#vacancy-job-types'
      //   }
      // },
      'Salary': (state) => {
        const inputs = state.vacancyEdit.main.salaryInputs

        return {
          check: inputs.salary_fix.value ||
            inputs.salary_from.value !== null && inputs.salary_to.value !== null,
          sectionId: '#vacancy-salary'
        }
      },
      'Start date': (state) => {
        const inputs = state.vacancyEdit.main.inputs

        return {
          check: Array.isArray(inputs.job_start_date.value) && inputs.job_start_date.value[0],
          sectionId: '#vacancy-start-date'
        }
      },
      'Job duration': (state) => {
        return {
          check: state.vacancyEdit.main.inputs.job_duration.value,
          sectionId: '#vacancy-job-duration'
        }
      },
    }
  }, {
    title: 'Vacancy characteristics',
    subItems: {
      'Schedule': (state) => {
        return {
          check: state.vacancyEdit.characteristicsSchedule.inputs.type.value,
          sectionId: '#vacancy-characteristic-schedule'
        }
      },
      'Salary': (state) => {
        return {
          check: state.vacancyEdit.characteristicsSalary.inputs.char_salary_type_id.value,
          sectionId: '#vacancy-characteristic-salary'
        }
      },
      'Housing': (state) => {
        return {
          check: state.vacancyEdit.characteristicsInhabitancy.inputs.char_inhabitancy_type_id.value,
          sectionId: '#vacancy-characteristic-housing'
        }
      },
    }
  }, {
    title: 'Place of work',
    subItems: {
      'Information about the company': (state, getters) => {
        return {
          check: getters['vacancyEdit/workPlace/isFilledInfo'],
          sectionId: '#vacancy-place-about'
        }
      },
      'Work address': (state, getters) => {
        return {
          check: getters['vacancyEdit/workPlace/isFilledAddress'],
          sectionId: '#vacancy-place-address'
        }
      }
    }
  }, {
    title: 'Applicant requirements',
    subItems: {
      'Age': (state, getters) => {
        return {
          check: getters['vacancyEdit/requirements/isFilledAge'],
          sectionId: '#vacancy-requirements-age'
        }
      },
      'Experience': (state, getters) => {
        return {
          check: getters['vacancyEdit/requirements/isFilledExp'],
          sectionId: '#vacancy-requirements-experience'
        }
      },
      'Certificates': (state) => {
        return {
          check: isFilledJSONValue(state.vacancyEdit.requirements.inputs.certificates.value),
          sectionId: '#vacancy-requirements-certificates'
        }
      },
      'Knowledge of the language': (state, getters) => {
        return {
          check: getters['vacancyEdit/requirements/isFilledLanguage'],
          sectionId: '#vacancy-requirements-language'
        }
      },
      'Physical form': (state, getters) => {
        return {
          check: getters['vacancyEdit/requirements/isFilledPhform'],
          sectionId: '#vacancy-requirements-physical'
        }
      }
    }
  }]

  export default {
    name: "VacancyEditProgress",
    components: {ProgressBar, OverlayScrollbarsComponent},
    props: {
      isSlide: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isOpen: false,
      }
    },
    computed: {
      resultList() {
        return this.createResultList()
      },
      progress() {
        const results = {
          true: 0,
          false: 0
        }

        this.resultList.forEach(item => {
          item.subItems.forEach(subItem => {
            if (subItem[1]) {
              results.true += 1
            } else {
              results.false += 1
            }
          })
        })

        return Math.round(100 / (results.true + results.false) * results.true)
      },
    },
    methods: {
      onSlideToggle() {
        this.isOpen = !this.isOpen
      },
      createResultList() {
        return items.map(item => {
          const state = this.$store.state
          const getters = this.$store.getters

          const subItems = Object.entries(item.subItems).map(([key, value]) => {
            return createSubItem(state, getters, key, value)
          })

          return {
            title: item.title,
            subItems
          }
        })
      }
    }
  }

  function createSubItem(state, getters, itemKey, itemValue) {
    if (typeof itemValue !== 'function') return false

    const result = itemValue(state, getters)
    return [itemKey, result.check, result.sectionId]
  }
</script>

<style>

</style>
